<template>
    <form class="search-bar" @submit.prevent="submit">
        <MagnifyIcon class="search-bar__icon" :size="20"></MagnifyIcon>

        <input
            ref="input"
            class="search-bar__input"
            :placeholder="placeholder"
            :value="value"
            @input="input($event.target.value)"
        />

        <button class="search-bar__clear" type="button" title="Очистить" v-if="value" @click="clear">
            <CloseIcon :size="18"></CloseIcon>
        </button>
        <span class="search-bar__kbd" v-else>/</span>

        <button class="search-bar__submit" type="submit">Найти</button>
    </form>
</template>

<script>
import MagnifyIcon from 'vue-material-design-icons/Magnify.vue';
import CloseIcon from 'vue-material-design-icons/Close.vue';

export default {
    components: {
        MagnifyIcon,
        CloseIcon,
    },

    props: {
        value: {
            type: String,
            default: '',
        },
        placeholder: {
            type: String,
            default: '',
        },
    },

    methods: {
        input(value) {
            this.$emit('input', value);
        },

        submit() {
            this.$emit('submit', this.value);
        },

        // Крестик обязан не только очистить поле, но и применить очистку: иначе строка
        // поиска пустая, а список продолжает показывать результаты прежнего запроса.
        clear() {
            this.$emit('input', '');
            this.$emit('submit', '');
        },

        // По шине приходит смена раздела: поле чистим, а применять нечего — следом
        // отрабатывает filters.init и сбрасывает запрос целиком.
        clearValue() {
            this.$emit('input', '');
        },

        onKeydown(event) {
            if (event.ctrlKey || event.metaKey || event.altKey) return;
            if (event.key !== '/') return;

            const target = event.target;
            const tag = target && target.tagName ? target.tagName.toLowerCase() : '';
            if (tag === 'input' || tag === 'textarea' || (target && target.isContentEditable)) return;

            event.preventDefault();
            this.$refs.input.focus();
        },
    },

    created() {
        this.$bus.on('tools:clear', this.clearValue);
        this.$bus.on('search:clear', this.clearValue);
    },

    mounted() {
        window.addEventListener('keydown', this.onKeydown);
    },

    beforeDestroy() {
        this.$bus.off('tools:clear', this.clearValue);
        this.$bus.off('search:clear', this.clearValue);
        window.removeEventListener('keydown', this.onKeydown);
    },
};
</script>

<style lang="scss">
.search-bar {
    display: flex;
    align-items: center;
    width: 100%;
    height: 44px;
    padding: 0 5px 0 14px;
    border: 1.5px solid #e3e5e8;
    border-radius: 12px;
    background: var(--color-white);
    transition: border-color 0.15s, box-shadow 0.15s;

    &:focus-within {
        border-color: $green;
        box-shadow: 0 0 0 3px rgba(0, 165, 90, 0.12);
    }

    &__icon {
        color: #9aa0a6;
        flex: none;
    }

    &__input {
        flex: 1;
        min-width: 60px;
        border: 0;
        outline: 0;
        background: transparent;
        padding: 0 12px;
        font: 400 0.875rem var(--font-family);
        color: #3c4043;

        &::placeholder {
            color: #9aa0a6;
        }
    }

    &__clear {
        width: 28px;
        height: 28px;
        margin-right: 2px;
        flex: none;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 0;
        border-radius: 50%;
        background: transparent;
        color: #9aa0a6;
        cursor: pointer;

        &:hover {
            background: #f6f7f8;
            color: #3c4043;
        }
    }

    &__kbd {
        flex: none;
        font: 500 0.6875rem var(--font-family);
        color: #9aa0a6;
        border: 1px solid #e3e5e8;
        border-radius: 5px;
        padding: 2px 7px;
        margin-right: 10px;
    }

    &__submit {
        flex: none;
        height: 34px;
        border: 0;
        border-radius: 9px;
        background: $green;
        color: var(--text-white);
        font: 500 0.8125rem var(--font-family);
        padding: 0 20px;
        cursor: pointer;

        &:hover {
            background: #15754a;
        }
    }
}

@media (max-width: $mobile-breakpoint) {
    .search-bar__kbd {
        display: none;
    }
}
</style>
